<!--
 * @Description  : 平台服务 --- 安招采-移动认证服务 -- 详情弹窗
 * @Author       : 王帅
 * @Date         : 2026-01-16 15:01:53
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-04-28 15:47:26
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\components\mobileCa-detail.vue
-->
<template>
	<div>
		<el-dialog :visible.sync="visible" v-bind="dialogOptions" @close="handleClose">
			<Panel title="#1 服务信息">
				<el-form ref="serviceInfo" :model="pageInfo" label-width="130px" class="tableForm">
					<el-form-item label="服务类型">
						<div>{{ currentRow.goodsName }}</div>
					</el-form-item>
					<el-form-item label="状态">
						{{ currentRow.payStatusText }}
					</el-form-item>
					<el-form-item label="服务有效期">
						<div>{{ activeTab == 'company' ? `${currentRow.serviceTime}` : `${currentRow.userTime}` }}</div>
					</el-form-item>
				</el-form>
			</Panel>
			<Panel title="#2 组合商品信息" v-if="pageInfo.payList && pageInfo.payList.length > 0">
				<vxe-table align="center" :data="pageInfo.payList" border>
					<vxe-table-column type="seq" title="序号" width="80px"></vxe-table-column>
					<vxe-table-column title="赠送商品" field="goodsName" min-width="130px"></vxe-table-column>
					<vxe-table-column title="数量" field="goodsNum" width="120px"></vxe-table-column>
				</vxe-table>
			</Panel>
			<Panel :title="`#${pageInfo.payList && pageInfo.payList.length > 0 ? 3 : 2} 支付信息`" v-if="dialogOptions.type == 'detail'">
				<el-form ref="infoForm" :model="pageInfo" label-width="130px" class="tableForm">
					<el-form-item label="开通人">
						<div>{{ pageInfo.payUserName }}</div>
					</el-form-item>
					<el-form-item label="开通单位">
						<div>{{ pageInfo.payCompanyName }}</div>
					</el-form-item>
					<el-form-item label="开通时间">
						<div>{{ pageInfo.createDate }}</div>
					</el-form-item>
					<el-form-item label="支付金额">
						<el-input v-model="pageInfo.goodsMoney" disabled>
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
				</el-form>
			</Panel>
			<Panel
				:title="`#${pageInfo.payList && pageInfo.payList.length > 0 ? 4 : 3} 关闭记录`"
				v-if="pageInfo.closeStatus == 1 && dialogOptions.type == 'detail'"
			>
				<el-form ref="closeForm" :model="pageInfo" label-width="130px" class="tableForm">
					<el-form-item label="服务关闭时间">
						<div>{{ pageInfo.serviceEndTime }}</div>
					</el-form-item>
					<el-form-item label="关闭原因">
						<div>{{ pageInfo.closeRemark }}</div>
					</el-form-item>
					<el-form-item label="操作人">
						<div>{{ pageInfo.closeUserName }}</div>
					</el-form-item>
					<el-form-item label="操作时间">
						<div>{{ pageInfo.closeDate }}</div>
					</el-form-item>
				</el-form>
			</Panel>

			<!-- 主动关闭服务 -->
			<Panel :title="`#${pageInfo.payList && pageInfo.payList.length > 0 ? 3 : 2} 关闭记录`" v-if="['close', 'closePay'].includes(dialogOptions.type)">
				<el-form ref="closeForm" :model="closeForm" label-width="130px" class="tableForm">
					<el-form-item label="关闭服务日期" prop="closeTime" required>
						<el-date-picker v-model="closeForm.closeTime" type="date" placeholder="选择日期"> </el-date-picker>
					</el-form-item>
					<el-form-item label="关闭原因" class="special-label" prop="closeRemark" required>
						<el-input type="textarea" :rows="2" :maxlength="50" show-word-limit placeholder="请输入内容" v-model="closeForm.closeRemark">
						</el-input>
					</el-form-item>
					<el-form-item label="操作人">
						<div>{{ closeForm.closeUserName }}</div>
					</el-form-item>
					<el-form-item label="操作时间">
						<div>{{ nowDate }}</div>
					</el-form-item>
				</el-form>
			</Panel>

			<!-- 确认关闭 -->
			<div slot="footer" class="text-center" v-if="['close', 'closePay'].includes(dialogOptions.type)">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="doSubmit" :loading="btnLoading">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as Api from '@/api/modules/platform-service/index.js'
import Panel from 'components/panel/Panel'
import { mapState } from 'vuex/dist/vuex.common.js'
export default {
	name: '',
	components: {
		Panel
	},
	props: {
		activeTab: {
			type: String,
			default: ''
		},
		// 状态文字
		statusText: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			visible: false,
			dialogOptions: {
				title: '服务详情',
				width: '800px',
				type: 'detail'
			},
			btnLoading: false,
			// 行信息存储
			currentRow: {},
			// 页面信息
			pageInfo: {},
			// 关闭表单
			closeForm: {},
			nowDate: this.$utils.toDateString(new Date(), 'yyyy-MM-dd HH:mm:ss')
		}
	},
	methods: {
		// 打开弹窗
		openDialog(type, row) {
			this.currentRow = Object.assign({}, row)
			this.dialogOptions.title = type == 'detail' ? '服务详情' : '关闭服务'
			this.dialogOptions.type = type

			this.visible = true
			this.getPageInfo(row.id)
		},

		// 关闭弹窗
		handleClose() {
			this.visible = false
			this.pageInfo = {}
			this.closeForm = {}
			this.btnLoading = false
		},

		//TODO 获取数据
		getPageInfo(id) {
			let params = { id }
			Api.getCaServiceDetail(params)
				.then((res) => {
					this.pageInfo = res.data
					if (['close', 'closePay'].includes(this.dialogOptions.type)) {
						this.closeForm.closeUserName = this.userInfo.sname
						this.closeForm.closeTime = this.$utils.toDateString(new Date(), 'yyyy-MM-dd')

						setTimeout(() => {
							this.$refs.closeForm ? this.$refs.closeForm.clearValidate() : ''
						}, 100)
					}
				})
				.catch((err) => {})
		},

		// 确认关闭弹窗
		doSubmit() {
			this.btnLoading = true
			this.$refs.closeForm.validate((valid) => {
				if (!valid) {
					this.$message.warning('请完善关闭信息！')
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
					return
				}

				let params = {
					id: this.currentRow.id,
					...this.closeForm
				}

				let apiName = this.dialogOptions.type == 'close' ? 'turnOffService' : 'updateMainDetail'
				Api[apiName](params)
					.then((res) => {
						this.$message.success('关闭成功！')
						this.handleClose()
						// 刷新父页面列表
						this.$parent ? this.$parent.getData() : ''
					})
					.catch((err) => {})
					.finally(() => {
						setTimeout(() => {
							this.btnLoading = false
						}, 2000)
					})
			})
		}
	},
	computed: {
		...mapState('user', { userInfo: (state) => state.userInfo })
	}
}
</script>
<style scoped lang="less">
/deep/.el-form {
	&.tableForm {
		.el-form-item {
			margin-bottom: 0;
			margin-right: 0;
			display: flex;
		}

		.el-form-item__label {
			width: 200px;
			// border: 0;
			border: 1px solid #dcdcdc;
			border-right: 0;
			border-bottom: 0;
			line-height: 46px;
			// margin: 0 1px;
			background: #fafafa;
			padding-right: 20px;
		}

		.el-form-item__content {
			border: 1px solid #dcdcdc;
			border-bottom: 0;
			width: calc(100% - 110px);
			background-color: #fff;
			line-height: 46px;
			text-align: left;
			margin-left: 0 !important;
			padding-left: 20px;
		}

		.special-label .el-form-item__content {
			padding-left: 0;
		}

		.el-form-item:last-child {
			.el-form-item__content,
			.el-form-item__label {
				border-bottom: 1px solid #dcdcdc;
			}
		}

		.el-input {
			width: 100%;
		}

		.el-input__inner {
			min-height: 46px !important;
			line-height: 46px !important;
			padding-left: 0px;
			border: 0;
			border-radius: 0;
		}

		.vxe-switch {
			padding-left: 20px;
		}

		.el-input.is-active .el-input__inner,
		.el-input__inner:focus {
			border: 1px solid #ccc;
		}

		.el-date-editor .el-input__inner {
			padding-left: 30px;
		}

		.el-form-item.is-error .el-input__inner,
		.el-form-item.is-error .el-input__inner:focus,
		.el-form-item.is-error .el-textarea__inner,
		.el-form-item.is-error .el-textarea__inner:focus {
			border: 1px solid #f56c6c;
		}

		.el-select {
			width: 100%;
		}

		.el-switch,
		.el-checkbox-group,
		.el-radio-group {
			margin-left: 20px;
		}

		.el-textarea__inner {
			border: none;
			border-radius: 0;
			padding-left: 20px;
		}

		.el-textarea .el-input__count {
			background-color: rgba(255, 255, 255, 0);
			bottom: -10px;
		}

		.el-textarea__inner:focus {
			border: 1px solid #dcdcdc;
			outline: none;
			border-color: #409eff;
		}

		.el-cascader {
			width: 100%;
		}

		.el-input-group__append,
		.el-input-group__prepend {
			background-color: #f4f7fa;
			color: #666;
			border-color: transparent;
		}
	}

	.el-input.is-disabled .el-input__inner {
		background-color: #fff;
	}
}
</style>
